import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import ContactPage from './pages/contact/ContactPage';
import MainPage from './pages/main/MainPage';
import AboutPage from './pages/about/AboutPage';
import BusinessPage from './pages/business/BusinessPage';
import NewsPage from './pages/news/NewsPage';
import CorePage from './pages/core/CorePage';
import LocationPage from './pages/location/LocationPage';
import { NavermapsProvider } from 'react-naver-maps';
import NewsDetailPage from './pages/news/NewsDetailPage';
import ScrollToTop from './components/ScrollToTop';
import TermsEthicsPage from './pages/terms/TermsEthicsPage';
import TermsPrivacyPage from './pages/terms/TermsPrivacyPage';
import Error404Page from './pages/error/Error404Page';

function App() {
  return (
    <NavermapsProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path='/' element={<MainPage />} />
            <Route path='/about' element={<AboutPage />} />
            <Route path='/business' element={<BusinessPage />} />
            <Route path='/core' element={<CorePage />} />
            <Route path='/news' element={<NewsPage />} />
            <Route path='/news/detail/:id' element={<NewsDetailPage />} />
            <Route path='/contact' element={<ContactPage />} />
            <Route path='/location' element={<LocationPage />} />
            <Route path='/terms/ethics' element={<TermsEthicsPage />} />
            <Route path='/terms/privacy' element={<TermsPrivacyPage />} />
            <Route path='*' element={<Error404Page />} />
          </Routes>
        </BrowserRouter>
      </div>
    </NavermapsProvider>
  );
}

export default App;
